import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({ standalone: false,
    selector: 'irb-color-category',
    template: `
        <div class="irb-color-category-div" [ngStyle]="{'background-color': categoryColor}"></div>
        <span tooltip [tooltipTitle]="params.value" [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='20'>
            {{params.value}}
        </span>
    `,
    styles: ['.irb-color-category-div { width: 15px;height: 15px;display: inline-block;margin-right: 5px;}']
})
export class ColorCategoryComponent implements AgRendererComponent {
    params: any;
    categoryColor: string;

    agInit(params: any) {
        this.params = params;
        this.categoryColor = params.data.categoryColor;
    }

    refresh(): boolean {
        return false;
    }
}
